import { useEditField, useFieldConfig } from '@atlassian/jira-issue-field-base';
import { getFieldType } from '@atlassian/jira-issue-view-common-utils';
import { FIX_VERSIONS_TYPE, AFFECTS_VERSIONS_TYPE } from '@atlassian/jira-platform-field-config';
import type { VersionFieldProps, VersionFieldValue, VersionResponse, VersionSaveId } from './types';

// @deprecated - remove this hook and use useVersionsFields hook for both fields - fix-versions and affects-versions
// on forge-ui-modifications-affects-versions-field-support-iv_ff6mj FF clean up
export const useFixVersionField = ({ issueKey, onSuccess, onFailure }: VersionFieldProps) => {
	const [fieldConfig] = useFieldConfig(issueKey, FIX_VERSIONS_TYPE);
	const fieldType = getFieldType(fieldConfig.value) || 'array';
	const [{ value, loading, error }, { saveValue, saveById, resetError }] = useEditField<
		VersionFieldValue,
		null,
		VersionResponse,
		VersionSaveId
	>({
		fieldKey: FIX_VERSIONS_TYPE,
		issueKey,
		fieldType,
		initialValue: null,
		onSuccess,
		onFailure,
	});

	return [
		{ value, loading, error, fieldConfig },
		{ saveValue, saveById, resetError },
	] as const;
};

export const useVersionsFields = ({
	issueKey,
	fieldKey = AFFECTS_VERSIONS_TYPE,
	onSuccess,
	onFailure,
}: VersionFieldProps) => {
	const [fieldConfig] = useFieldConfig(issueKey, fieldKey);
	const fieldType = getFieldType(fieldConfig.value) || 'array';
	const [{ value, loading, error }, { saveValue, saveById, resetError }] = useEditField<
		VersionFieldValue,
		null,
		VersionResponse,
		VersionSaveId
	>({
		fieldKey,
		issueKey,
		fieldType,
		initialValue: null,
		onSuccess,
		onFailure,
	});

	return [
		{ value, loading, error, fieldConfig },
		{ saveValue, saveById, resetError },
	] as const;
};
